'use strict';

var _ = require('lodash');
var FaresOptimizerAuditLogModalDirective = function FaresOptimizerAuditLogModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-audit-log-modal.html'),
    controller: 'FaresOptimizerAuditLogModalController',
    scope: {
      auditLogCallback: '=',
      showAuditLogModal: '=',
      auditLogModalData: '='
    },
    link: function link($scope, $element) {
      $scope.$watch('showAuditLogModal', function (newVal) {
        if (newVal) {
          $scope.selectedItemCount = $scope.auditLogModalData.count;
          $element.modal('show');
          $scope.showAuditLogModal = false;
        }
      });
    }
  };
};
FaresOptimizerAuditLogModalDirective.$inject = [];
module.exports = FaresOptimizerAuditLogModalDirective;